module.exports = __webpack_public_path__ + "static/media/022yhkgl.342a5029.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/022yhkgl.jpg
// module id = 638
// module chunks = 0 1